// extracted by mini-css-extract-plugin
export default {"card":"components-market-smart-insights-card-smart-insights-module__card","badge":"components-market-smart-insights-card-smart-insights-module__badge"};